import { observer } from "mobx-react";
import { Router, Route, Redirect } from "react-router-dom";
import { Box } from "@mui/material";
import Header from "./components/Header";
import AppDrawer from "./components/AppDrawer";
import About from "./pages/About";
import Antibiotics from "./pages/Antibiotics";
import Calendar from "./pages/Calendar";
import CareDays from "./pages/CareDays";
import Help from "./pages/Help";
import Home from "./pages/Home";
import Immunoglobulin from "./pages/Immunoglobulin";
import MyNotes from "./pages/MyNotes";
import EQ5D5L from "./pages/EQ5D5L";
import SickDays from "./pages/SickDays";
import SymptomDiary from "./pages/SymptomDiary";
import Vaccination from "./pages/Vaccination";
import Login from "./pages/Login";
import Error from "./components/Error";
import Loading from "./components/Loading";
import { useStoreContext } from ".";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import isToday from "dayjs/plugin/isToday";
import isTomorrow from "dayjs/plugin/isTomorrow";
import weekday from "dayjs/plugin/weekday";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import localeData from "dayjs/plugin/localeData";
import localizedFormat from "dayjs/plugin/localizedFormat";
import minMax from "dayjs/plugin/minMax";
import isoWeek from "dayjs/plugin/isoWeek";
import advancedFormat from "dayjs/plugin/advancedFormat";
import timezone from "dayjs/plugin/timezone";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";
import dayjs from "dayjs";

import "dayjs/locale/sv";
import StatusSnackBar from "./components/StatusSnackBar";
dayjs.extend(isToday);
dayjs.extend(isTomorrow);
dayjs.extend(weekday);
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(minMax);
dayjs.extend(isoWeek);
dayjs.extend(advancedFormat);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.tz.setDefault("Europe/Stockholm");

const App = observer(({ history }: { history: any }) => {
  const { userStore, keycloakStore } = useStoreContext();

  if (keycloakStore.error || userStore.error.size) {
    return <Error />;
  }

  if (keycloakStore.loading) {
    return <Loading />;
  }

  if (!keycloakStore.isAuthenticated) {
    return <Login />;
  }

  if (keycloakStore.isAuthenticated && !userStore.user) {
    return <Loading />;
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"sv"}>
      <Box className="app-root-main">
        <Box className="main" id="scrollTarget">
          <Header />
          <AppDrawer />
          <Box className="content-main">
            <StatusSnackBar />
            <Router history={history}>
              <Route path="/about">
                <About />
              </Route>
              <Route path="/antibiotics">
                <Antibiotics />
              </Route>
              <Route path="/calendar">
                <Calendar />
              </Route>
              <Route path="/caredays">
                <CareDays />
              </Route>
              <Route path="/help">
                <Help />
              </Route>
              <Route path="/home">
                <Home />
              </Route>
              <Route path="/immunoglobulin">
                <Immunoglobulin />
              </Route>
              <Route path="/mynotes">
                <MyNotes />
              </Route>
              <Route path="/EQ-5D-5L">
                <EQ5D5L />
              </Route>
              <Route path="/sickdays">
                <SickDays />
              </Route>
              <Route path="/symptomdiary">
                <SymptomDiary />
              </Route>
              <Route path="/vaccination">
                <Vaccination />
              </Route>
              <Route path="/">
                <Redirect to="/home" />
              </Route>
            </Router>
          </Box>
        </Box>
      </Box>
    </LocalizationProvider>
  );
});

export default App;
